// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane-XqwSjdg","rows":"rows-2BY-B62","row":"row-3B1bPdS","nowBtn":"nowBtn-4xR410y","tourBtn":"tourBtn-3-cJ8wL","showSettings":"showSettings-33lR-2Z","local":"local-1EjYWpd"};